export class ProductThumbnail {

    refNo: number;
    fileName: string;
    fileType: string;
    productCode: number;
}
